import { Title } from '@angular/platform-browser';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { createUrlResolverWithoutPackagePrefix } from '@angular/compiler';
declare var bootbox:any;
@Component({
  selector: 'app-distributed-survey-new',
  template: require('./distributed-survey-new.component.html')
})
export class DistributedSurveyNewComponent extends BaseComponent implements OnInit {

  public surveyId = -1;

  public organizations = [];
  public managers = [];
  public surveys = [];

  public selectedOrganizationId = null;
  public selectedManagerId = null;
  public selectedSurveyId = null;

  public surveyDescription = "";
  public surveyInstructions = "";
  public surveyTitle = "";

  public msg = "";
  public targetedEmployees = "";

  public survey = {
    title:"",
    organizationId : -1,
    surveyId : -1,
    description: "",
    instructions: "",
    managerName: "fnln",
    usePrefix: 0,
    defaultEmailFolder: "",
    defaultReportFunction: ""
  };

  ngOnInit() {
    super.ngOnInit();

    this.msg = "select a manager";
    this.targetedEmployees = "";
    this.loadOrganizations();
  }


  public loadSurveyById() {
    this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
            this.selectedOrganizationId = this.survey.organizationId;
            this.selectedSurveyId = this.survey.surveyId;
            //this.surveyDescription = this.survey.description;
            //this.surveyInstructions = this.survey.instructions;
            this.updateTextWithVariables();
            this.surveyTitle = this.survey.title;
            this.loadManagers();
        }
    },
    error => {
        console.log(error);
    });
  }

  public routeParamsUpdated() {
    this.surveyId = this.default(this.currentRouteParams["surveyId"],-1);
    if(this.surveyId>0) {
     this.loadSurveyById();
    }
    else 
      this.surveyId = -1;
  }

  public loadOrganizations() {
    this.busy = this.lsApi.getOrganizations().subscribe(resp => {
      if(resp.status) {
          this.organizations = resp.data;
      }
    },
    error => {
        console.log(error);
    });
  }

  public getOrganizationById(id) {
    var selectedOrg = null;
    this.organizations.forEach(org => {
      if(org.organizationId == parseInt(id)) {
        selectedOrg = org;
      }
    });
    return selectedOrg;
  }

  public getDepartment(mgr) {
    if(mgr.department!=null)
      return " (" + mgr.department.name + " - " + mgr.email + ")";
    else
      return "";
  }

  public loadManagers() {
    this.busy = this.lsApi.getManagersWithEmployees(this.selectedOrganizationId,-1).subscribe(resp => {
      if(resp.status) {
          this.managers = resp.data;
      }
    },
    error => {
        console.log(error);
    });
  }

  public updateTextWithVariables() {
    var selectedOrg = this.getOrganizationById(this.selectedOrganizationId);
    if(selectedOrg!=null) {
      this.surveyDescription = this.survey.description.replace("|CompanyName|",selectedOrg.name);
      this.surveyInstructions = this.survey.instructions.replace("|CompanyName|",selectedOrg.name);
    }
    else {
      this.surveyDescription = this.survey.description;
      this.surveyInstructions = this.survey.instructions;
    }
    var today = new Date();
    var year = today.getFullYear();
    var monthInt = today.getMonth() + 1;
    var monthText = "";
    switch (monthInt) {
      case 1:
        monthText = "January";
        break;
        case 2:
        monthText = "February";
        break;
        case 3:
        monthText = "March";
        break;
        case 4:
        monthText = "April";
        break;
        case 5:
        monthText = "May";
        break;
        case 6:
        monthText = "June";
        break;
        case 7:
        monthText = "July";
        break;
        case 8:
        monthText = "August";
        break;
        case 9:
        monthText = "September";
        break;
        case 10:
        monthText = "October";
        break;
        case 11:
        monthText = "November";
        break;
        case 12:
        monthText = "December";
        break;
    }
    this.surveyDescription = this.surveyDescription.replace("|FullMonth|",monthText);
    this.surveyInstructions = this.surveyInstructions.replace("|FullMonth|",monthText);
    this.surveyDescription = this.surveyDescription.replace("|FullYear|",year + "");
    this.surveyInstructions = this.surveyInstructions.replace("|FullYear|",year + "");

  }

  public organizationSelected() {
    this.loadManagers();
    //this.loadSurveys();
    this.updateTextWithVariables();
    this.msg = "select a manager";
    this.targetedEmployees = "";
  }

  public managersEmployees = [];

  public loadManagersEmployees() {
    if(this.selectedManagerId==-1 || this.selectedManagerId==null) {
      return;
    }
    this.msg = "processing...";
    this.lsApi.getManagersEmployees(this.selectedManagerId).subscribe(resp => {
      if(resp.status) {
          this.managersEmployees = resp.data;
          this.targetedEmployees = this.managersEmployees.length + "";
          this.msg = "employee(s) targeted";
      }
    },
    error => {
        console.log(error);
    });
  }


  public loadSurveys() {
    this.busy = this.lsApi.getSurveys().subscribe(resp => {
      if(resp.status) {
          this.surveys = resp.data;
          this.surveyDescription = "";
          this.surveyInstructions = "";
      }
    },
    error => {
        console.log(error);
    });
  }

  public getSurveyById(id) {
    for(var i = 0;i<this.surveys.length;i++) {
      var survey = this.surveys[i];
      if(survey.surveyId == id) {
        return survey;
      }
    }

  }

  public managerSelected() {
    this.loadManagersEmployees();
  }

  public surveySelected() {
    var survey = this.getSurveyById(this.selectedSurveyId);
    console.log(survey);
    //this.surveyDescription = survey.description.replace("|CompanyName|",this.getOrganizationById(this.selectedOrganizationId).name);
    //this.surveyInstructions = survey.instructions.replace("|CompanyName|",this.getOrganizationById(this.selectedOrganizationId).name);
    this.updateTextWithVariables();

  }

  public distribute() {

    if(this.surveyDescription == "") {
      bootbox.alert("Please provide a description for this survey.");
      return;
    }
    if(this.surveyInstructions == "") {
      bootbox.alert("Please provide instructions for this survey.");
      return;
    }
    if(this.managersEmployees.length<=0) {
      bootbox.alert("Please select a manager which has at least one employee under him/her.");
      return;
    }

    var usePrefix = 0;
    if(this.survey.usePrefix)
      usePrefix = 1;

      var orgId = this.selectedOrganizationId;
    
    this.busy = this.lsApi.distributeSurvey(this.surveyId, usePrefix, this.survey.managerName, orgId, this.selectedManagerId, this.surveyTitle,this.surveyDescription, this.surveyInstructions,
      this.survey.defaultEmailFolder, this.survey.defaultReportFunction).subscribe(resp => {
      if(resp.status) {
        this.router.navigate(['/admin/survey-distribution-queue']).then(() => {
          this.appToast.success("Survey Successfully Queued for Distribution","Distribution Queued");
        })
      }
    },
    error => {
        console.log(error);
    });

  }

  public cancel() {
    this.router.navigate(['/admin/surveys']);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/distributed-survey-new/distributed-survey-new.component.ts